class LatestBlogs extends HTMLElement {
  constructor() {
    super();
    this.sliderWrapper = this.querySelector(".latest-blogs__posts .swiper");
    this.nextButton = this.sliderWrapper.querySelector(".swiper-button-next");
    this.prevButton = this.sliderWrapper.querySelector(".swiper-button-prev");
    this.swiper = null;
  }
  connectedCallback() {
    if (this.sliderWrapper) {
      this.initializeSliders();
    }

    if (this.swiper) {
      this.swiper.on("reachEnd", () => {
        console.log("End reached");
        this.nextButton.classList.add("swiper-button-disabled");
      });
    }
  }

  initializeSliders() {
    this.swiper = new Swiper(this.sliderWrapper, {
      spaceBetween: 16,
      slidesPerView: "auto",
      navigation: {
        nextEl: this.nextButton,
        prevEl: this.prevButton,
      },
    });
  }
}

customElements.define("latest-blogs", LatestBlogs);
